import { CommonModule } from '@angular/common';
import { Component, computed, inject, Input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { GalaxyAbstractFilterChip, GalaxyFilterValueInterface } from '@vendasta/galaxy/filter/chips';
import { CrmInjectionToken } from '@galaxy/crm/static';
import { Pipeline, PipelinesApiService } from '@vendasta/crm';

@Component({
  template: `
    @if (pipelineIds().length > 0) {
      @if (selectedPipelines(); as pipelines) {
        <span>{{ pipelines }}</span>
      } @else {
        <div class="stencil-shimmer"></div>
      }
    }
  `,
  styles: [
    `
      .stencil-shimmer {
        width: 50px;
        height: 16px;
      }
    `,
  ],
  imports: [CommonModule],
})
export class CrmPipelineFilterChipComponent implements GalaxyAbstractFilterChip {
  @Input() set initialValue(value: GalaxyFilterValueInterface[]) {
    this.pipelineIds.set(value?.map((v) => v.string ?? '') || []);
  }

  private readonly config = inject(CrmInjectionToken);
  private readonly pipelineService = inject(PipelinesApiService);
  private readonly pipelines = toSignal(this.listPipelines());

  protected readonly pipelineIds = signal<string[]>([]);
  protected readonly selectedPipelines = computed(() => {
    const pipelineIds = this.pipelineIds();
    const pipelines = this.pipelines();
    return pipelineIds
      .map((pipelineId) => pipelines?.find((pipeline) => pipeline.pipelineId === pipelineId))
      .map((pipeline) => pipeline?.name)
      .join(', ');
  });

  private listPipelines(): Observable<Pipeline[]> {
    return this.config.namespace$.pipe(
      switchMap((namespace) =>
        this.pipelineService.listPipelines({ listOptions: { namespace: namespace, objectType: 'Opportunity' } }),
      ),
      map((response) => response.pipelines),
    );
  }
}
